export const getAllLoadingPromises = (state = { loadingPromises: {} }) =>
  state.loadingPromises;

export default {
  getAllLoadingPromises,
};



// WEBPACK FOOTER //
// ./src/redux-modules/loading-overlay/selectors/index.js